const { Core, Utils, Events } = Global;
const { $loading } = Utils;

customElements.define('cart-loader', class extends Core { 

    render() {
        import('./dio-laceband-cart.js?v=20260907-dismiss').then(({ installLaceBandOffer }) => {
            this.dioLaceBand = installLaceBandOffer(this, 'page');
            this.sub(Events.CART_UPDATE, this.dioLaceBand.refresh, { global: true });
        }).catch(() => {});
        this.sub(Events.CART_CHANGE, this._handleCartChange, { global: true });
        this.sub(Events.CART_REPLACE, this._handleCartChange, { global: true });
        this.sub(Events.CART_ERROR, this._handleCartError, { global: true });
    }

    _handleCartChange({ key }) {
        this.updatingProduct = this.querySelector(`[data-item-key="${key}"]`);
        if(!this.updatingProduct) {
            return;
        }

        $loading(this.updatingProduct);
    }

    _handleCartError() {
        this.updatingProduct && $loading(this.updatingProduct, false);
    }
})